// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./css/components/_page.scss
// module id = 45
// module chunks = 0